<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Restocking'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <div class="wizard-progress-bar">
        <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
      </div>

      @if (currentStep === 1) {
        <div class="wizard-step-header">
          <tidy-text [title]="'What is the bed / bath count at this property?'" />
        </div>

        <div class="wizard-cards">
          @for (option of homeSizes; track option.value) {
            <tidy-card
              class="wizard-card"
              (click)="selectHomeSize(option)">
              <div class="wizard-card-radio" [ngClass]="selectedHomeSize === option.value ? 'wizard-card-radio-selected' : ''">
                <span class="wizard-card-radio-inner"></span>
              </div>
              <div class="wizard-card-text">
                <tidy-text [body]="option.viewValue" />
              </div>
            </tidy-card>
          }
        </div>
      }

      @if (currentStep === 2) {
        <div class="wizard-step-header">
          <tidy-text [title]="'Confirm what you have at this property'" />
        </div>
        <div class="wizard-step-header">
          <tidy-text [body]="'Check each item you already have. We\'ll use this to help you buy anything you\'re missing.'" />
        </div>

        <div class="wizard-content">
          @for (group of groupVms; track group.label) {
            @if (group.visibleItems.length) {
            <tidy-row class="restocking-group-header extra-top-padding">
              <tidy-text [header]="group.label" />
            </tidy-row>
            @for (item of group.visibleItems; track item.id) {
              <tidy-card class="restocking-item-card">
                <div class="restocking-item-row">
                  <tidy-checkbox
                    [items]="item.checkboxItems"
                    [initValue]="item.form.controls.have.value"
                    (checkedChange)="toggleHave(item, $event)" />
                  @if (item.recommendedLabel) {
                    <div class="restocking-recommended">
                      <tidy-text [helper]="item.recommendedLabel" />
                    </div>
                  }
                </div>
                @if (item.form.controls.have.value) {
                  <form [formGroup]="item.form" class="restocking-item-fields" novalidate action="#">
                    @if (item.requiresQuantity) {
                      <tidy-row>
                        <tidy-input
                          [label]="'Quantity'"
                          formControlName="quantity"
                          [form]="item.form.controls.quantity"
                          [inputMode]="'numeric'"
                          [submitted]="submitted"
                          [errorMessage]="'Please enter a quantity (numbers only)'" />
                      </tidy-row>
                    }
                    <tidy-row>
                      <tidy-textarea
                        [label]="'Details (optional)'"
                        formControlName="details"
                        [form]="item.form.controls.details" />
                    </tidy-row>
                  </form>
                }
              </tidy-card>
            }
            }
          }

          <div class="wizard-nav-row">
            <tidy-button
              [text]="isSaving ? 'Saving...' : 'Submit'"
              [action]="submit"
              [disabled]="isSaving"
              class="primary" />
          </div>

          @if (!fromGettingStarted) {
            <tidy-row [align]="'center'">
              <tidy-text
                [actionBody]="'Skip for now'"
                (action)="skipStep()"
                class="link" />
            </tidy-row>
          }
        </div>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
